<div class="widget-list">
  <app-risk-widget [config]="loggedWidget"></app-risk-widget>
  <app-risk-widget [config]="assessedWidget"></app-risk-widget>
  <app-risk-widget [config]="remainingWidget"></app-risk-widget>
</div>
